// extracted by mini-css-extract-plugin
export default {"task_modal":"taskModal_task_modal__RQzjN"};